export enum AttributesSearchParam {
    ActionAndFun = 'ac',
    AdultsOnly = 'oa',
    Ayurveda = 'ay',
    BabyCot = 'bb',
    BabySitting = 'bs',
    BeautyFarm = 'bf',
    BuggyRent = 'bl',
    CentralLocation = 'ce',
    CharmFlair = 'cf',
    ChildFriendly = 'fv',
    ChildrensBuffet = 'cb',
    ChildrensPlayground = 'pg',
    ChildrensPlayroom = 'pr',
    ChildrensPool = 'cp',
    CityBreaks = 'ct',
    Club = 'club',
    Cosmetic = 'bt',
    CulinaryDelights = 'cu',
    Cycling = 'cc',
    Deluxe = 'del',
    DirectBeachAccess = 'beach',
    Diving = 'dv',
    FamilyHoliday = 'family',
    Fitness = 'fit',
    FreeParking = 'fp',
    FreeWLAN = 'fw',
    GayHotel = 'gh',
    GentlySlopingSandyBeach = 'fb',
    GermanSpeakingEntertainmentForKids = 'ga',
    Golf = 'go',
    GreatSportsOffer = 'so',
    HandicappedAccessible = 'ha',
    HeatedPool = 'hpo',
    Hiking = 'hk',
    HolidayForTwo = 'co',
    HorseRiding = 'ri',
    HotelNearTheBeach = 'nb',
    IndoorPool = 'ip',
    Internet = 'net',
    KidsDisco = 'cd',
    LaundryService = 'la',
    LonghaultJourney = 'lh',
    Massages = 'msg',
    MaxiClub = 'max',
    MedicalService = 'ms',
    MiniClub = 'min',
    NiceSmallFamilyRun = 'fr',
    NonSmokingHotel = 'nos',
    NonSmokingRooms = 'nosr',
    ParkingSpacesAvailable = 'pa',
    PettingZoo = 'pz',
    Pool = 'po',
    RelaxationOffersForBodyAndSoul = 'rx',
    Restaurant = 'rst',
    Sailing = 'sa',
    SandyBeach = 'sb',
    Sauna = 'sn',
    Singles = 'sg',
    SingleWithChild = 'sic',
    SoccerSchool = 'sc',
    SportOffersForChildren = 'cs',
    Squash = 'sq',
    Surfing = 'sur',
    Kitesurfing = 'ksur',
    SwimSchool = 'ss',
    Tennis = 'te',
    Thalasso = 'th',
    VacationAtMediterraneanSea = 'mt',
    VacationAtNorthOrBalticSea = 'bc',
    VacationInAustria = 'at',
    VacationInGermany = 'ge',
    VacationInTheMountains = 'mo',
    WaterSlide = 'las',
    WaterSports = 'was',
    Wellness = 'wellness',
    Windsurfing = 'wsur',
    WinterSports = 'wis',
    Wingfoiling = 'wfoi',
    BabyEquipment = 'be',
    PetsAllowed = 'pe',
    QuietLocation = 'ql',
    HoneymoonTravel = 'ht',
}

export enum SearchParam {
    AccommodationCategoryList = 'acg',
    Adult = 'adult',
    AirlineList = 'airlineList',
    Airport = 'airport',
    AreaGroupId = 'areaGroupId',
    AreaId = 'areaId',
    BudgetMax = 'budgetMax',
    BudgetMin = 'budgetMin',
    Cancellation24Hours = 'cdbts',
    CancellationCost = 'cancellationCost',
    CancellationFree = 'cancellationShortlyBefore',
    ChildrenCount = 'childrenCount',
    CityId = 'cityId',
    CountryId = 'countryId',
    CtsDestination = 'destinationTag',
    Days = 'days',
    DepartureDate = 'departureDate',
    DepartureFlightTimeFrom = 'departureFlightTimeFrom',
    DepartureFlightTimeUntil = 'departureFlightTimeUntil',
    DestinationAirportList = 'destinationAirportList',
    DirectFlight = 'directFlight',
    DirectHotelSearchId = 'dhs',
    DirectSearch = 'ds',
    ExteriorList = 'rf',
    FlightDistance = 'distance',
    GeoFence = 'geoPoints',
    HideMixFlights = 'moca',
    HotelCategory = 'hotelCategory',
    HotelCategoryList = 'hotelCategoryList',
    HotelCategoryMulti = 'hotelCategoryMulti',
    HotelId = 'hotelId',
    HotelMaxCategory = 'hotelMaxCategory',
    HotelTransfer = 'transfer',
    LowDeposit = 'lowDeposit',
    MealTypeList = 'cateringList',
    OceanView = 'oceanView',
    Page = 'page',
    PaymentTypeList = 'offerPaymentTypeList',
    PoolTypeList = 'pool',
    PrivateTransfer = 'privateTransfer',
    PromoDiscount = 'promoDiscount',
    RailAndFly = 'railAndFly',
    Rating = 'rating',
    Rebookable = 'flexBooking',
    Reservable = 'cancellationOption',
    ReservablePredicted = 'predictedCancellation',
    ReturnDate = 'returnDate',
    ReturnFlightTimeFrom = 'returnFlightTimeFrom',
    ReturnFlightTimeUntil = 'returnFlightTimeUntil',
    RoomCount = 'roomCount',
    RoomAllocation = 'roomAllocation',
    RoomClassList = 'rc',
    RoomTypeList = 'roomType',
    SortHotel = 'sorting',
    SortOffer = 'offerSort',
    SortRegion = 'areaSort',
    TourOperatorCategoryList = 'touroperatorwhitelist',
    TouroperatorList = 'touroperator',
    ViewTypeList = 'view',
    WithHygieneFacts = 'hf',
    WithNoBag = 'wnb',
    PartialOceanView = 'partialOceanView',
}

export enum QueryParams {
    Lead = 'lead',
}

export enum SemParams {
    CacheInformation = 'cacheInformation',
    SemBadge = 'semBadge',
    Source = 'source',
}

export const knownParams = new Set<string>([
    ...Object.values(SearchParam),
    ...Object.values(AttributesSearchParam),
]);

export const paramTruthyValue = '1';
export const paramTransferValue = 'transfer';
export const paramDurationExactValue = 'exact';
